import { lazy } from "react";

//site page
export const Login = lazy(() => import("../../pages/site/Login"));
export const Home = lazy(() => import("../../pages/site/Home"));
export const Courses = lazy(() => import("../../pages/site/Courses"));
export const ClassDetailsFindById = lazy(() => import("../../pages/site/Courses/CourseDetail"));
export const AboutUs = lazy(() => import("../../pages/site/AboutUs"));
export const ContactUs = lazy(() => import("../../pages/site/ContactUs"));
//system pages
export const Dashboard = lazy(() => import("../../pages/system/Dashboard"));
export const TheCourses = lazy(() => import("../../pages/system/Courses"));
export const CourseDetail = lazy(() => import("../../pages/system/CourseDetail"));
export const Classes = lazy(() => import("../../pages/system/Classes"));
export const ClassDetail = lazy(() => import("../../pages/system/ClassDetail"));
export const ClassAssignments = lazy(() => import("../../pages/system/Classes/Assignments"));
export const ClassAssignment = lazy(() => import("../../pages/system/Classes/Assignments/Assignment"));
export const Workshops = lazy(() => import("../../pages/system/Workshops"));
export const WorkshopDetails = lazy(() => import("../../pages/system/WorkshopDetails"));
export const Students = lazy(() => import("../../pages/system/Students"));
export const TheTeachers = lazy(() => import("../../pages/system/Teachers"));
export const Requests = lazy(() => import("../../pages/system/Requests"));
export const RequestDetails = lazy(() =>
  import("../../pages/system/RequestDetails")
);
export const TheScheduledCourses = lazy(() =>
  import("../../pages/system/ScheduledCourses")
);
export const Schedule = lazy(() => import("../../pages/system/Schedule"));
export const MyStudents = lazy(() => import("../../pages/system/MyStudents"));
export const ClassesStudents = lazy(() => import("../../pages/system/ClassesStudents"));
export const PaymentsAndInvoices = lazy(() => import("../../pages/system/PaymentsAndInvoices"));
export const PermissionsAndRoles = lazy(() => import("../../pages/system/PermissionsAndRoles"));
export const PageNotFound = lazy(() => import("../../pages/site/PageNotFound"));
